import { Box, Button, Divider, Stack, SwipeableDrawer } from '@mui/material';
import { styled } from '@mui/material/styles';
import { BOTTOM_SHEET_PICKER_CONSTANTS } from '../constants';

const {
  ITEM_HEIGHT,
  SELECTED_HEIGHT,
  ITEM_GAP,
  ITEM_SLOT,
  CONTAINER_HEIGHT,
  DONE_BUTTON_PADDING_X,
  DONE_BUTTON_PADDING_Y,
  DONE_BUTTON_HEIGHT,
  VISIBLE_ITEMS,
  FONT_SIZE_LARGE,
  FONT_SIZE_MEDIUM,
  FONT_SIZE_SMALL,
  OPACITY_LARGE,
  OPACITY_MEDIUM,
  OPACITY_SMALL,
} = BOTTOM_SHEET_PICKER_CONSTANTS;

export const StyledDrawer = styled(SwipeableDrawer)(({ theme }) => ({
  '& .MuiDrawer-paper': {
    overflow: 'hidden',
    backgroundColor: theme.palette.background.paper,
  },
}));

export const StyledHeader = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: theme.spacing(2, 4),
  backgroundColor: theme.palette.secondaryInvert.main,
}));

export const StyledTitle = styled(Box)(({ theme }) => ({
  ...theme.typography.subtitle2,
  fontWeight: theme.typography.fontWeightMedium,
  color: theme.palette.common.white,
}));

export const StyledDoneButton = styled(Button)(({ theme }) => ({
  ...theme.typography.body2,
  fontWeight: theme.typography.fontWeightMedium,
  color: theme.palette.common.white,
  borderColor: theme.palette.common.white,
  borderRadius: theme.customShape.borderRadiusFull,
  padding: theme.spacing(DONE_BUTTON_PADDING_Y, DONE_BUTTON_PADDING_X),
  height: theme.spacing(DONE_BUTTON_HEIGHT),
  minWidth: 'auto',
  textTransform: 'none',
}));

export const StyledHeaderDivider = styled(Divider)(({ theme }) => ({
  borderColor: theme.palette.divider,
}));

export const StyledPickerWrapper = styled(Box)({
  position: 'relative',
  overflow: 'hidden',
});

export const StyledPickerContainer = styled(Box)(({ theme }) => ({
  position: 'relative',
  zIndex: 1,
  height: theme.spacing(CONTAINER_HEIGHT),
  overflowY: 'auto',
  scrollSnapType: 'y mandatory',
  WebkitOverflowScrolling: 'touch',
  paddingTop: theme.spacing(ITEM_SLOT * ((VISIBLE_ITEMS - 1) / 2)),
  paddingBottom: theme.spacing(ITEM_SLOT * ((VISIBLE_ITEMS - 1) / 2)),
  '&::-webkit-scrollbar': {
    display: 'none',
  },
  scrollbarWidth: 'none',
}));

const getFontSize = (distance: number): number => {
  if (distance === 0) return FONT_SIZE_LARGE;
  if (distance === 1) return FONT_SIZE_MEDIUM;
  return FONT_SIZE_SMALL;
};

const getOpacity = (distance: number): number => {
  if (distance === 0) return OPACITY_LARGE;
  if (distance === 1) return OPACITY_MEDIUM;
  return OPACITY_SMALL;
};

export const StyledPickerItem = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'distance',
})<{ distance: number }>(({ theme, distance }) => ({
  height: theme.spacing(distance === 0 ? SELECTED_HEIGHT : ITEM_HEIGHT),
  marginBottom: theme.spacing(ITEM_GAP),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  scrollSnapAlign: 'center',
  fontSize: theme.typography.pxToRem(getFontSize(distance)),
  fontWeight: theme.typography.fontWeightMedium,
  opacity: getOpacity(distance),
  color:
    theme.palette.mode === 'dark'
      ? theme.palette.common.white
      : theme.palette.text.main,
  transition:
    'font-size 0.15s ease, opacity 0.15s ease, font-weight 0.15s ease, height 0.15s ease',
  userSelect: 'none',
  cursor: 'default',
}));

export const StyledSelectionBand = styled(Box)(({ theme }) => ({
  position: 'absolute',
  left: 0,
  right: 0,
  top: '50%',
  transform: 'translateY(-50%)',
  height: theme.spacing(SELECTED_HEIGHT),
  backgroundColor: theme.palette.background.blue,
  pointerEvents: 'none',
}));
